module.exports = "<p>\r\n  common works!\r\n</p>\r\n"